var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.applicationNotFound)?[_c('router-view'),_c('eds-wrapper',{ref:"edsCreateWrapper",on:{"mounted":_vm.onMountedEdsWrapper}}),_c('qr-code-modal',{ref:"qrCodeCreateModal",on:{"mounted":_vm.onMountedQrCodeModal}})]:[_c('error'),_c('application-not-found',{staticClass:"v-application mainClass"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }